import React, { useContext, useEffect, useState, useCallback } from "react";
import Header from "./Comman/Header";
import { OnmaxContext } from "../OnmaxContext";
import axios from "axios";
import Pagination from "./Comman/Pagination";

export default function WithdrwlHistory() {
  const { formatDateTime, formatAddress, copyaddress } = useContext(OnmaxContext);
  const [data, setdata] = useState([]);
  const [isLoading, setisLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [pages, setPages] = useState(1);
  const username = localStorage.getItem("username");


  const getData = useCallback(async () => {
    if (!username) {
      return;
    }
    setisLoading(true);

    await axios
      .post(process.env.REACT_APP_BACKEND_LINK, {
        method: "withdrawal",
        submethod: "getwithid",
        username: username,
        key: process.env.REACT_APP_KEY,
        page: currentPage,
        pageSize: pageSize,

      })
      .then((res) => {
        setisLoading(false);

        // var dedata = decryptData(res.data);
        if (res.data.error) {
          return "";
        }
        setdata(res.data.data);
        setPages(Math.ceil(res.data.total / pageSize));

      });
  }, [username, currentPage, pageSize]);

  useEffect(() => {
    getData();
  }, [getData]);


  return (
    <>
      <div className="body-bg">
        <Header />
        <section className="nftmax-adashboard nftmax-show mt-4 setting-section">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-12">

                {/* Card Container */}
                <div className="db-profile-card mb-5">

                  {/* Card Header */}
                  <div className="db-sec-hdr">
                    <div className="db-sec-dot"></div>
                    <div className="db-sec-title">Withdrawal History</div>
                  </div>

                  <div className="card-body p-0 mt-3">
                    <div className="table-responsive">
                      <table className="table table-dashboard-premium align-middle mb-0" style={{ minWidth: '900px' }}>
                        <thead className="text-uppercase small">
                          <tr>
                            <th scope="col" className="ps-4 py-3">Sr.</th>
                            <th scope="col" className="py-3">Hash</th>
                            <th scope="col" className="py-3">Address</th>
                            <th scope="col" className="py-3">Amount</th>
                            <th scope="col" className="py-3">Fees(%)</th>
                            <th scope="col" className="py-3">Total Receive</th>
                            <th scope="col" className="pe-4 py-3 text-end">Date</th>
                          </tr>
                        </thead>
                        <tbody>
                          {isLoading && !data.length ? (
                            <tr>
                              <td colSpan="7" className="text-center py-5">
                                <div className="spinner-border text-primary" role="status">
                                  <span className="visually-hidden">Loading...</span>
                                </div>
                              </td>
                            </tr>
                          ) : !data.length ? (
                            <tr>
                              <td colSpan="7" className="text-center py-5 text-slate-400">
                                <p className="mb-0">No data found</p>
                              </td>
                            </tr>
                          ) : (
                            data.map((ele, i) => {
                              const index = currentPage * pageSize - pageSize + (i + 1);
                              return (
                                <tr key={i} className="table-tr-premium">
                                  <td className="ps-4">
                                    <span className="text-slate-400 small">{index}</span>
                                  </td>

                                  <td>
                                    <span
                                      className="text-primary cursor-pointer small"
                                      onClick={() => copyaddress(ele.hash)}
                                      style={{ cursor: 'pointer' }}
                                    >
                                      {ele.hash ? formatAddress(ele.hash) : '-'} <i className="fa fa-copy ms-1"></i>
                                    </span>
                                  </td>

                                  <td>
                                    <span
                                      className="text-white-custom small"
                                      onClick={() => copyaddress(ele.address)}
                                      style={{ cursor: 'pointer' }}
                                    >
                                      {ele.address ? formatAddress(ele.address) : '-'} <i className="fa fa-copy ms-1 text-slate-400"></i>
                                    </span>
                                  </td>

                                  <td>
                                    <span className="fw-bold text-white-custom">${ele.amount}</span>
                                  </td>

                                  <td>
                                    <div className="d-flex flex-column">
                                      <span className="text-danger small">${ele.fee ? ele.fee.toFixed(2) : 0}</span>
                                      <span className="text-slate-400 text-xs">({ele.fee_per}%)</span>
                                    </div>
                                  </td>

                                  <td>
                                    <span className="badge bg-soft-success fw-bold p-2">${ele.totalrcv ? ele.totalrcv.toFixed(2) : 0}</span>
                                  </td>

                                  <td className="pe-4 text-end">
                                    {ele.date ? (
                                      <span className="text-slate-400 small">{formatDateTime(ele.date)}</span>
                                    ) : '-'}
                                  </td>
                                </tr>
                              );
                            })
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* Card Footer for Pagination */}
                  <div className="card-footer bg-transparent border-top border-secondary border-opacity-10 p-4">
                    <Pagination
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                      pageSize={pageSize}
                      setPageSize={setPageSize}
                      pages={pages}
                    />
                  </div>

                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
